import { useFlightCampaigns } from './useFlightCampaigns'
import { HOMEPAGE_FLIGHT_DEALS_REGIONS } from 'constants/config/region'
import { useContext } from 'react'
import GeoContext from 'contexts/geoContext'
import useFlightDeals from './useFlightDeals'

const HOME_PAGE_CAMPAIGNS_THRESHOLD = 4
const HOME_PAGE_FLIGHT_DEALS_THRESHOLD = 5

export function useShowFlightCampaignsOrDeals(isHomepage: boolean = false): 'deals' | 'campaigns' | 'none' {
  const { currentRegionCode } = useContext(GeoContext)
  const [campaigns, fetchingCampaigns, campaignsEnabled] = useFlightCampaigns()
  const [flightDeals, fetchingFlightDeals] = useFlightDeals()

  if (fetchingCampaigns) {
    return 'none'
  }

  if (campaignsEnabled && (!isHomepage || campaigns.length >= HOME_PAGE_CAMPAIGNS_THRESHOLD)) {
    return 'campaigns'
  }

  if (fetchingFlightDeals) {
    return 'none'
  }

  const flightDealsEnabled = isHomepage ?
    HOMEPAGE_FLIGHT_DEALS_REGIONS.includes(currentRegionCode) && flightDeals.length >= HOME_PAGE_FLIGHT_DEALS_THRESHOLD :
    true

  if (flightDealsEnabled) {
    return 'deals'
  }

  return 'none'
}
